/**
 * Sanitizes strings for jsPDF standard fonts.
 * Strips Unicode emojis and unsupported glyphs while preserving German umlauts and standard punctuation.
 */
export function cleanPdfText(str: string): string {
  if (!str) return '';
  return str
    .replace(/[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE00}-\u{FE0F}\u{1F300}-\u{1F6FF}\u{1F900}-\u{1F9FF}\u{D800}-\u{DFFF}]/gu, '')
    .replace(/[^\x20-\x7E\xC0-\xFF\u0100-\u017F\s\-&.,()\/+]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}
